import { useCallback, useEffect, useRef, useState } from 'react';
import isEqual from 'fast-deep-equal';
export function useStateValue(value, deps, options) {
    if (deps === void 0) { deps = []; }
    var optionsRef = useState({ current: options })[0];
    var mountedRef = useState({ isMount: true })[0];
    var setNextValue = useState(value)[1];
    var depsRef = useRef(deps);
    var valueRef = useRef(value);
    optionsRef.current = options;
    useEffect(function () {
        return function () {
            mountedRef.isMount = false;
        };
    }, []);
    var setValue = useCallback(function (value) {
        var _a, _b;
        if (!mountedRef.isMount) {
            return;
        }
        var prevValue = valueRef.current;
        if (value !== prevValue) {
            valueRef.current = value;
            setNextValue(value);
            (_b = (_a = optionsRef.current) === null || _a === void 0 ? void 0 : _a.onChange) === null || _b === void 0 ? void 0 : _b.call(_a, value, prevValue);
        }
    }, []);
    var updateValue = useCallback(function (updater) {
        if (!mountedRef.isMount) {
            return;
        }
        setValue(updater(valueRef.current));
    }, []);
    var getValue = useCallback(function () { return valueRef.current; }, []);
    useEffect(function () {
        var _a;
        if (!((options === null || options === void 0 ? void 0 : options.depsComparator) || isEqual)(depsRef.current, deps)) {
            depsRef.current = deps;
            var prevValue = valueRef.current;
            setValue(value);
            (_a = options === null || options === void 0 ? void 0 : options.onReset) === null || _a === void 0 ? void 0 : _a.call(options, value, prevValue);
            return;
        }
    });
    return {
        getValue: getValue,
        setValue: setValue,
        updateValue: updateValue
    };
}
//# sourceMappingURL=useStateValue.js.map